<div class="main container" [hidden]="!(loggedin && profileOn)">
    <div class="page-header">
        <h1>{{LOCALIZATION.profile}}</h1>
    </div>
    <div class="row">
    	<div class="col-sm-3">
			<ul ngbNav #nav="ngbNav" [activeId]="activeTab" class="nav nav-tabs nav-stacked flex-column" orientation="vertical">
			  <li [domId]="'userDetails'" id="userDetails-tab" ngbNavItem class="nav-item">
			    <a class="nav-link" ngbNavLink>
			      {{ LOCALIZATION.editAccountDetails }}
			    </a>			    
			    <ng-template ngbNavContent>
	                <div class="col-xs-5">
	                
		                <!-- Form displaying user account details -->
						<user-details></user-details>
	
	                </div> 
			    </ng-template>
			  </li>
			  <li ngbNavItem class="nav-item" [hidden]="!changePassword">
			    <a class="nav-link" ngbNavLink>
			      {{ LOCALIZATION.changePassword }}
			    </a>			    
			    <ng-template ngbNavContent>
	                <div class="col-xs-5">
	                
	                	<!-- Form displaying user pwd details -->
						<user-password></user-password>                    
	                    
	                </div>
			    </ng-template>
			  </li>
			  <li ngbNavItem class="nav-item">
			    <a class="nav-link" ngbNavLink>
			      {{ LOCALIZATION.fields }}
			    </a>			    
			    <ng-template ngbNavContent>
	                <div class="col-xs-12">
	                
		                	<!-- Form displaying user fields preferences -->
							<user-fields></user-fields>

	                </div>
	                <br>
					<button 
						type="submit" 
						class="btn btn-primary pull-right" 
						(click)="saveFieldsAndOrders()" 
						title="Update search preferences" >
							{{LOCALIZATION.update}}
					</button>					    
			    </ng-template>
			  </li>	
			  <li ngbNavItem class="nav-item" [hidden]="userPermissions['BLOCK_LIBRARIES_PREF']">
			    <a class="nav-link" ngbNavLink>
			      {{ LOCALIZATION.libraries }}
			    </a>			    
			    <ng-template ngbNavContent>
	                <div class="col-xs-12">
	                	<div style="max-height:60vh;overflow-y:auto">
	                	
		                	<!-- Form displaying user library preferences -->
							<user-libraries></user-libraries>
						
						</div>
	                </div>				    
			    </ng-template>
			  </li>
			  <li ngbNavItem class="nav-item" [hidden]="userPermissions['BLOCK_SEARCH_PREF']">
			    <a class="nav-link" ngbNavLink>
			      {{ LOCALIZATION.preferencesSearch }}
			    </a>			    
			    <ng-template ngbNavContent>
	                <div class="col-xs-12 col-lg-9">
	                
		                	<!-- Form displaying user search preferences -->
							<user-search-opts></user-search-opts>
							
	                </div>					    
			    </ng-template>
			  </li>
			  <li ngbNavItem class="nav-item" [hidden]="userPermissions['BLOCK_INTERNATIONAL_PREF']">
			    <a class="nav-link" ngbNavLink>
			      {{ LOCALIZATION.preferencesInternational }}
			    </a>			    
			    <ng-template ngbNavContent>
	                <div class="col-xs-12 col-lg-9">
	                
		                	<!-- Form displaying user international preferences -->
							<user-international-opts></user-international-opts>
	 
	                </div>				    
			    </ng-template>
			  </li>
			  <li ngbNavItem class="nav-item" [hidden]="userPermissions['BLOCK_RESULTS_PREF']">
			    <a class="nav-link" ngbNavLink>
			      {{ LOCALIZATION.preferencesResults }}
			    </a>			    
			    <ng-template ngbNavContent>
	                <div class="col-xs-12 col-lg-9">
	                
	                    <!-- Form displaying user results preferences -->
						<user-results-opts></user-results-opts>
	
	                </div>				    
			    </ng-template>
			  </li>
			  <li ngbNavItem class="nav-item" [hidden]="userPermissions['BLOCK_DISPLAY_PREF']">
			    <a class="nav-link" ngbNavLink>
			      {{ LOCALIZATION.preferencesDisplay }}
			    </a>				    
			    <ng-template ngbNavContent>
	                <div class="col-xs-12 col-lg-9">
	                
	               	    <!-- Form displaying user UI display preferences -->
						<user-display-opts></user-display-opts>
	
	                </div>				    
			    </ng-template>
			  </li>
			  <li ngbNavItem [domId]="'messages'" id="messages-tab" class="nav-item">
			    <a class="nav-link" ngbNavLink>
			      {{ LOCALIZATION.messages }} <span class="badge">{{messageCount}}</span>
			    </a>			    
			    <ng-template ngbNavContent>
			    
	   				<!-- Table displaying user messages -->
					<user-messages></user-messages>	
										    
			    </ng-template>
			  </li>
			</ul>   
		</div> 	
		
        <div class="col-xs-12 col-sm-9">
        	<div [ngbNavOutlet]="nav" class="tab-content"></div>
        </div>
    </div>
</div>
<div class="main container" *ngIf="!loggedin || !profileOn">
    <div class="text-center full-center">
        <h1><span style="font-size:3em" class="glyphicon glyphicon-remove-sign text-red"></span></h1>
        <h3><span>{{LOCALIZATION.loginPolite}}</span></h3>
    </div>
</div>